<app-cookie-notice />
<div class="layout">
  <header class="topbar">
    <div class="topbar__main">
      <a
        class="brand"
        routerLink="/"
        aria-label="Voltar para início"
        (click)="closeMobileMenu()"
      >
        <picture class="brand-picture">
          <source media="(max-width: 768px)" srcset="assets/logo-mobile.png" />
          <img
            src="assets/logo.png"
            width="165"
            height="46"
            alt="AccessHub"
            class="brand-logo"
            fetchpriority="high"
            decoding="async"
          />
        </picture>
      </a>

      <div class="topbar-mobile-actions">
        <a
          class="topbar-mobile-chip"
          routerLink="/baixar-ingressos"
          aria-label="Abrir página de ingressos"
          (click)="closeMobileMenu()"
        >
          Ingressos
        </a>
        <button
          class="topbar-mobile-toggle"
          type="button"
          [attr.aria-expanded]="mobileMenuOpen"
          aria-controls="mobile-nav"
          aria-label="Abrir menu"
          (click)="toggleMobileMenu()"
        >
          ☰
        </button>
      </div>
    </div>

    <form
      class="topbar-search"
      role="search"
      [formGroup]="searchForm"
      (ngSubmit)="submitSearch()"
    >
      <svg class="icon" aria-hidden="true" viewBox="0 0 24 24">
        <circle cx="10" cy="10" r="6" />
        <path d="m15 15 5 5" />
      </svg>
      <input
        [formControl]="search"
        type="search"
        placeholder="Buscar eventos, cidades ou categorias"
        aria-label="Buscar eventos"
      />
      <button
        class="search-submit"
        type="submit"
        aria-label="Pesquisar eventos"
      >
        →
      </button>
    </form>

    <nav class="nav-links nav-links--desktop" aria-label="Navegação principal">
      <a routerLink="/baixar-ingressos" routerLinkActive="active"
        >Baixar ingressos</a
      >
      <ng-container *ngIf="auth.user$ | async as user; else unauthTemplate">
        <button
          class="button button--primary"
          (click)="goToAdmin('/events/new')"
        >
          + Crie seu evento
        </button>
        <a routerLink="/account" routerLinkActive="active">Área do usuário</a>
      </ng-container>

      <ng-template #unauthTemplate>
        <a
          class="button button--primary"
          routerLink="/register"
          [queryParams]="{ intent: 'create-event' }"
        >
          + Crie seu evento
        </a>
        <a routerLink="/login" routerLinkActive="active">Entrar</a>
      </ng-template>
    </nav>

    <nav
      id="mobile-nav"
      class="mobile-nav"
      [class.mobile-nav--open]="mobileMenuOpen"
      aria-label="Navegação mobile"
    >
      <a routerLink="/eventos" (click)="closeMobileMenu()">Eventos</a>
      <a routerLink="/baixar-ingressos" (click)="closeMobileMenu()"
        >Baixar ingressos</a
      >
      <a routerLink="/ajuda" (click)="closeMobileMenu()">Ajuda</a>
      <a routerLink="/perguntas-frequentes" (click)="closeMobileMenu()"
        >Perguntas frequentes</a
      >

      <ng-container
        *ngIf="auth.user$ | async as user; else mobileUnauthTemplate"
      >
        <button
          class="button button--primary"
          type="button"
          (click)="goToAdmin('/events/new')"
        >
          + Crie seu evento
        </button>
        <a routerLink="/account" (click)="closeMobileMenu()">Área do usuário</a>
      </ng-container>

      <ng-template #mobileUnauthTemplate>
        <a
          class="button button--primary"
          routerLink="/register"
          [queryParams]="{ intent: 'create-event' }"
          (click)="closeMobileMenu()"
        >
          + Crie seu evento
        </a>
        <a routerLink="/login" (click)="closeMobileMenu()">Entrar</a>
      </ng-template>
    </nav>
  </header>

  <main class="content">
    <router-outlet></router-outlet>
  </main>

  <button
    class="scroll-top-button"
    type="button"
    aria-label="Voltar ao topo"
    (click)="scrollToTop()"
  >
    ↑
  </button>

  @defer (on viewport) {
  <app-footer />
  } @placeholder {
  <div class="footer footer--placeholder" aria-hidden="true"></div>
  }
</div>
